/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NB_AUTH_OPTIONS } from '@nebular/auth/auth.options';
import { getDeepFromObject } from '@nebular/auth/helpers';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { NbAuthResult } from '@nebular/auth';

import { NbAuthService } from '@nebular/auth/services/auth.service';

@Component({
  selector: 'ngx-request-password-page',
  styleUrls: ['./request-password.component.scss'],
  templateUrl: './request-password.component.html',
})
export class NgxRequestPasswordComponent implements OnInit{
  logo: string;
  redirectDelay = 0;
  showMessages: any = {};
  provider = '';

  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  user: any = {};

  constructor(protected service: NbAuthService,
              @Inject(NB_AUTH_OPTIONS) protected config = {},
              private http: HttpClient,
              protected router: Router) {

    this.redirectDelay = this.getConfigValue('forms.requestPassword.redirectDelay');
    this.showMessages = this.getConfigValue('forms.requestPassword.showMessages');
    this.provider = this.getConfigValue('forms.requestPassword.provider');
  }

  requestPass(): void {
    try {
      this.errors = this.messages = [];
      this.submitted = true;
  
      this.service.requestPassword(this.provider, this.user).subscribe((result: NbAuthResult) => {
        this.submitted = false;
        if (result.isSuccess()) {
          this.messages = result.getMessages();
        } else {
          this.errors = result.getErrors();
        }
  
        const redirect = result.getRedirect();
        if (redirect) {
          setTimeout(() => {
            return this.router.navigateByUrl(redirect);
          }, this.redirectDelay);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.config, key, null);
  }

  ngOnInit(): void {
    try {
      const headers: HttpHeaders = new HttpHeaders({
        'Content-Type': 'application/json',
      });
      const options =  {headers: headers};
      this.http
        .get('https://server.sinecta.com/api/v1/domains', options)
        .subscribe(
          (result: any) => {
            const full = window.location.host;
            const parts = full.split('.');
            const sub = parts[0];
            const domain = parts[1];
            if (sub.includes('localhost') || domain === 'sinecta') { // app.sinecta.com
              return this.logo = 'https://app.sinecta.com/assets/images/aura_gds_white.png';
            }
  
            const domains = result.find(d => d['name'] === sub);
            if (domain) {
              return this.logo = `https://server.sinecta.com/assets/images/domains/${domains.image}`;
            }
          });
    } catch (error) {
      console.log(error);
    }
  }
}
